import englishData from '../translations/en.json'
import portugueseData from '../translations/pt-BR.json'
import { Locale } from '@/service/api/landingPage'

export const getLPTranslationData = <
  TPortugueseData extends keyof typeof portugueseData,
  TContainerName extends keyof (typeof portugueseData)[TPortugueseData],
>({
  landingPage,
  container,
  locale,
}: {
  landingPage: TPortugueseData
  container: TContainerName
  locale: Locale
}) => {
  const localeMapping: {
    'pt-BR': typeof portugueseData
    en: typeof englishData
  } = {
    'pt-BR': portugueseData,
    en: englishData,
  }

  return localeMapping[locale][landingPage][container]
}
